<template>
  <div class="container activate">
    <h1 class="section-title">Reseller</h1>
    <p
      class="text-normal"
    >Enter the SIM Number below (found on the back of the SIM card) and click ‘Verify’ to get started.</p>
    <div class="activation-inputs">
      <div class="form-group" v-bind:class="{ 'has-errors': errors.has('employee_code') }">
        <input          
          type="text"
          v-validate="'required'"
          name="sim_number"
          class="form-control"
          data-vv-as="Employee Code"
          v-model="employee_code"
          placeholder="Enter your employee number"
        />
        <span
          class="error-message"
          v-if="errors.has('employee_code')"
        >A valid employee code is required.</span>
      </div>
      <a
        class="input-title"
        href="javascript:void(0);"
        v-on:click="display_sim_iccid_img = !display_sim_iccid_img"
      >Where is the SIM number?</a>
      <div class="text-center mt-4">
        <img
          src="assets/images/clipart/iccid.png"
          class="where-sim-no text-center"
          v-if="display_sim_iccid_img"
        />
      </div>
      <div class="form-group" v-bind:class="{ 'has-errors': errors.has('simNumber') }">
        <the-mask
          mask="####-####-####-####-###"
          type="tel"
          v-validate="'required|digits:19'"
          name="sim_number"
          class="form-control"
          data-vv-as="SIM Number"
          v-model="sim_number"
          placeholder="Enter the customers sim number"
        />
        <span
          class="error-message"
          v-if="errors.has('sim_number')"
        >A valid 19 digit sim number (ICCID) is required (eg: 8927071234567890123).</span>
      </div>
      <div class="error-message" v-if="error_message != ''">{{ error_message }}</div>
      <button type="button" class="btn-primary btn-block verify" v-on:click="verify">VERIFY</button>

    </div>
  </div>
</template>

<script>
import ValidationService from "@/services/validation.service.js";

export default {
  name: "sim-validation",
  data() {
    return {
      error_message: "",
      sim_number: "8927 07",
      display_sim_iccid_img: false,
      employee_code:""
    };
  },
  mounted() {
    var self = this;
    self.$scrollTo("body");
  },
  methods: {
    verify() {
      var self = this;
      self.is_loading = true;
      self.$validator.validateAll().then(success => {
        if (!success) return (self.is_loading = success);
        ValidationService.validateIccid(self.sim_number)
          .then(({ data }) => {
            var response = data;
            self.is_loading = false;
            //self.$log.debug(response.data);
            if (response.success) {
              if (response.data.assigned > 0) {
                self.error_message =
                  "SIM is already assigned to a customer. Please use another SIM or contact support.";
              } else {
                self.$emit("valid-sim", {sim_number: self.sim_number, employee_code: self.employee_code});
              }
            }
          })
          .catch(({ response }) => {
            self.is_loading = false;
            self.$log.error(response);
            self.error_message =
              "Unfortunately we cannot complete this request. Please contact support.";
          });
      });
    }
  }
};
</script>